<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <driver-detail [_visibleDetail]="visibleDetail"
                   [_driverId]="selectedDriver.Id"
                   [showEditFields]="showEditFields"
                   (changedVisibleDetailEmit)="changedVisibleDetailEmit($event)"
                   *ngIf="visibleDetail"></driver-detail>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <div class="onboarding-head flex mb-4">
            <div class="onboarding-head-fleft">
                <div class="onboarding-head-title">
                    Draft Registration
                </div>
            </div>
            <div class="flex flex-row onboarding-head-right">
                <span class="onboarding-head-date p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search here..." />
                </span>

                <div class="ml-3 mt-1">
                    <column-selector #columnSelector
                         [defaultColumns]="defaultCols"
                         (selectedColumnsChange)="onSelectedColumnsChange($event)"
                         [tableName]="tableName"
                         [(selectedColumns)]="cols">
                    </column-selector>
                </div>
            </div>
        </div>

        <!-- Table -->
        <p-table #xpressUsersGrid
                 [columns]="cols"
                 [value]="riders"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 selectionMode="single"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 [showFirstLastIcon]="false"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [selection]="selectedDriver"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(100vh - 230px)'}">
            <ng-template pTemplate="caption">
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="driverHeaderSearch[item.model]"
                                       (input)="handleHeaderFilterChange(item.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="driverHeaderSearch[item.model]"
                                               (ngModelChange)="handleHeaderFilterChange(item.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="driverHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange(item.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="driverHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange(item.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="driverHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange(item.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-driver>
                <tr [pSelectableRow]="driver" (click)="handleShowDriverInfo(driver)">
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container [ngSwitch]="item.field">
                            <ng-container *ngSwitchCase="'StatusText'">
                                <span class="onbg-status-col status-field-action"
                                      [style.color]="driver.StatusColor"
                                      [style.background-color]="driver.StatusBackColor">{{driver.Status}}</span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span class="onbg-status-col">
                                    {{driver[item.field]}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="riders.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + riders.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
